// src/features/statistics/components/GenderChart.tsx

import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

import type { GenderData } from '../types/audience';

type Props = {
  gender: GenderData | null;
};

const COLORS = { female: 'var(--chart-2)', male: 'var(--chart-1)', unknown: 'var(--muted-foreground)' };

export function GenderChart({ gender }: Props): JSX.Element {
  if (!gender) {
    return (
      <div className="flex items-center justify-center h-full min-h-[120px] text-sm text-muted-foreground">
        Нет данных
      </div>
    );
  }

  const data = [
    { name: 'Женщины', value: gender.female, color: COLORS.female },
    { name: 'Мужчины', value: gender.male, color: COLORS.male },
  ].filter(d => d.value > 0);

  return (
    <div className="flex flex-col items-center gap-2">
      <ResponsiveContainer width="100%" height={120}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={32}
            outerRadius={52}
            dataKey="value"
            strokeWidth={0}
          >
            {data.map(entry => (
              <Cell key={entry.name} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value: number) => [`${value}%`, '']}
            contentStyle={{ fontSize: 12, borderRadius: 8 }}
          />
        </PieChart>
      </ResponsiveContainer>
      <div className="flex gap-4 text-xs">
        {data.map(entry => (
          <span key={entry.name} className="flex items-center gap-1 text-muted-foreground">
            <span className="inline-block w-2 h-2 rounded-full flex-shrink-0" style={{ background: entry.color }} />
            {entry.name} {entry.value}%
          </span>
        ))}
      </div>
    </div>
  );
}
